import { Autocomplete, Button, DateRange, Field, Filter, SearchField } from "components/commons";
import VIPRedemptionStatus from "enums/vip-redemption-status";
import locale from "localization";
import React from "react";
import styles from "./redemption-history-filter.module.scss";

const statusOptions = [
  { label: locale.pending, value: VIPRedemptionStatus.Pending },
  { label: locale.success, value: VIPRedemptionStatus.Success },
  { label: locale.failed, value: VIPRedemptionStatus.Failed },
  { label: locale.expired, value: VIPRedemptionStatus.Expired },
];

const RedemptionHistoryFilter = ({
  filterState,
  applyFilter,
  applyClearFilter,
  applyResetFilter,
  modifyFilter,
  modifySearch,
  applySearch,
  applyClearSearch,
  searchKey,
  filterCount,
  exportReport,
  exporting,
  getUserAccess,
}) => {
  return (
    <div className={styles.filter}>
      <Filter
        submit={applyFilter}
        clear={applyClearFilter}
        close={applyResetFilter}
        filterCount={filterCount}
      >
        <Field
          labelPosition={"left"}
          childrenClassName={styles.fieldContent}
          label={locale.redemptionDate}
        >
          <DateRange
            value={{
              startDate: filterState.startDate,
              endDate: filterState.endDate,
            }}
            onChange={(_, { value }) => {
              const { startDate, endDate } = value;
              modifyFilter({
                startDate,
                endDate,
              });
            }}
          />
        </Field>
        <Field labelPosition={"left"} childrenClassName={styles.fieldContent} label={locale.status}>
          <Autocomplete
            capitalize={false}
            name={"statuses"}
            hasAll
            multiple
            placeholder="Select Status"
            value={filterState.statuses}
            options={statusOptions}
            onChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
      </Filter>
      <Field className={styles.search}>
        <SearchField
          restrict={false}
          placeholder={locale.vipRedemptionIdAndCashInId}
          value={searchKey}
          onChange={(_, { value }) => modifySearch(value)}
          onEnter={applySearch}
          onClear={applyClearSearch}
        />
      </Field>
      <Field className={styles.downloadButton}>
        {(getUserAccess?.fullAccess || getUserAccess?.exportAccess) && (
          <Button
            startIcon={<span className="icon-download" />}
            exportButton
            onClick={exportReport}
            disabled={exporting}
            loading={exporting}
          >
            {locale.export}
          </Button>
        )}
      </Field>
    </div>
  );
};

export default RedemptionHistoryFilter;
